import { render, staticRenderFns } from "./MainForQR.vue?vue&type=template&id=1c75400b"
import script from "./MainForQR.vue?vue&type=script&lang=ts"
export * from "./MainForQR.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports